
const urlBack = 'https://alice-accounting-essca.eu/Request.php'


const  BackendAPI = {
    login: async(dataConnexion)=>{
        console.log(dataConnexion) 
        
        const requestOptions = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
                type: "loginAdmin",
                data:  dataConnexion
            }),
            isConnected:false
        };
   
        try {
            const response = await fetch(urlBack, requestOptions);
            console.log(response)
            // Vérifiez si la réponse est OK avant d'essayer de lire le JSON
            if (!response.ok) {
                throw new Error(`Erreur HTTP : ${response.status}`);
            }
            // Analyser la réponse en JSON
            const data = await response.json();
            return data;
        } catch (error) {
            console.error("Erreur lors de la connexion :", error);
            return null;
        }
    },

    // Liste des étudiants, ou null si le serveur ne répond pas correctement
    // (avant : un objet d'erreur arrivait dans le tableau et la page plantait).
    getEtudiants:async()=>{
        try {
            const response = await fetch(urlBack, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ type:"getEtudiantsAccounting", data:{} }),
            })
            if (!response.ok) throw new Error(`Erreur HTTP : ${response.status}`)
            const data = await response.json()
            return Array.isArray(data) ? data : null
        } catch (error) {
            console.error("Erreur getEtudiants :", error)
            return null
        }
    },
    updateEtudiant:async(value,field,id)=>{
        const requestOptions = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
                type:"updateEtudiantAccounting",
                data:{
                    value:value,
                    field:field,
                    id:id
                }
            }),
            /* mode:'no-cors', */
            isConnected:false
        };
        const response = await  fetch(urlBack, requestOptions)
        
        return response
    },
    // Plusieurs champs d'un coup (Campus + Programme + Groupe restent cohérents).
    // toupdate : [{ field, value }, …]. Renvoie l'étudiant à jour, ou null.
    updateEtudiantChamps:async(id,toupdate)=>{
        try {
            const response = await fetch(urlBack, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ type:"updateEtudiantAccounting", data:{ id, toupdate } }),
            })
            if (!response.ok) throw new Error(`Erreur HTTP : ${response.status}`)
            const json = await response.json()
            return json && json.id !== undefined ? json : null
        } catch (error) {
            console.error("Erreur updateEtudiantChamps :", error)
            return null
        }
    },
    createUser:async(user)=>{
        const requestOptions = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
                type:"createEtudiantAccounting",
                data:{user:user}
            }),
            isConnected:false
        };

        const response = await  fetch(urlBack, requestOptions)
        return response
    },

    getQuestions:async(numJeu)=>{
        const formattedNumber = (parseInt(numJeu.split(" - ")[0], 10) + 10).toString().padStart(2, '0')
        const nomJeu = `questionsjeu${formattedNumber}`;
        console.log("TEST TEST "+nomJeu)
        const requestOptions = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            /* mode:"no-cors", */
            body: JSON.stringify({
                type:"getQuestions",
                data:{
                    nomJeu:nomJeu
                }
                
            }),
            isConnected:false
        };

        const response = await  fetch(urlBack, requestOptions)

        
        const data = await response.json()
        return  data

    },
    updateQuestion:async(value,field,id,numJeu)=>{

        const formattedNumber = (parseInt(numJeu.split(" - ")[0], 10) + 10).toString().padStart(2, '0')
        const nomJeu = `questionsjeu${formattedNumber}`;

        console.log(nomJeu+" "+field+" "+value+" "+id)

        const requestOptions = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
                type:"updateQuestion",
                data:{
                    value:value,
                    field:field,
                    id:id,
                    nomJeu:nomJeu
                }
                
            }),
           /*  mode:'no-cors', */
            isConnected:false
        };
        const response = await  fetch(urlBack, requestOptions)
        const data = await response.json()
        return data
    },
    createQuestion:async(question,numJeu)=>{
        const formattedNumber = (parseInt(numJeu.split(" - ")[0], 10) + 10).toString().padStart(2, '0')
        const nomJeu = `questionsjeu${formattedNumber}`;

        const requestOptions = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
                type:"createQuestionAccounting",
                data:{
                    question:question,
                    nomJeu:nomJeu
                }
                
            }),
            /* mode:'no-cors', */
            isConnected:false
        };

        const response = await  fetch(urlBack, requestOptions)

        return  await response.json()
    },

    getClassements:async()=>{
        const requestOptions = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
                type:"getClassementAccounting",
                data:{
                    idUser:-1
                }
                
            }),
            /* mode:'no-cors', */
            isConnected:false
        };

        const response = await  fetch(urlBack, requestOptions)

        return  await response.json()
    },

    // ── Liste de référence Campus → Programme → Groupe (page Groupes) ──
    // Chaque ligne : { id, campus, programme, groupe, nbEtudiants }.
    // null si la liste n'a pas pu être lue (à ne pas confondre avec une liste vide).
    getGroupes:async()=>{
        try {
            const response = await fetch(urlBack, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ type:"getGroupesAccounting", data:{} }),
            })
            if (!response.ok) throw new Error(`Erreur HTTP : ${response.status}`)
            const data = await response.json()
            return Array.isArray(data) ? data : null
        } catch (error) {
            console.error("Erreur getGroupes :", error)
            return null
        }
    },
    // Réponses : { ok: true } ou { ok: false, erreur: "doublon" | "parametres" | … }
    createGroupe:async(groupe)=>BackendAPI.envoyerGroupe("createGroupeAccounting", groupe),
    updateGroupe:async(id,field,value)=>BackendAPI.envoyerGroupe("updateGroupeAccounting", { id, field, value }),
    deleteGroupe:async(id)=>BackendAPI.envoyerGroupe("deleteGroupeAccounting", { id }),
    envoyerGroupe:async(type,data)=>{
        try {
            const response = await fetch(urlBack, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ type, data }),
            })
            if (!response.ok) throw new Error(`Erreur HTTP : ${response.status}`)
            const json = await response.json()
            return json && typeof json === 'object' ? json : { ok: false }
        } catch (error) {
            console.error("Erreur " + type + " :", error)
            return { ok: false, erreur: "reseau" }
        }
    },

    // Devis 2026-1 : meilleurs scores et temps de jeu par étudiant / jeu / niveau.
    // dateDebut / dateFin au format "YYYY-MM-DD" (null = pas de filtre).
    getScoresNiveaux:async(dateDebut=null,dateFin=null)=>{
        const requestOptions = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
                type:"getScoresNiveauxAccounting",
                data:{
                    dateDebut:dateDebut,
                    dateFin:dateFin
                }
            }),
            isConnected:false
        };
        try {
            const response = await fetch(urlBack, requestOptions)
            if (!response.ok) throw new Error(`Erreur HTTP : ${response.status}`)
            const data = await response.json()
            return Array.isArray(data) ? data : null
        } catch (error) {
            console.error("Erreur getScoresNiveaux :", error)
            return null   // ≠ [] : erreur, pas « aucune partie »
        }
    },

    // Pages « Stats Application » et « Stats Jeux » (comme Play & Learn).
    // Renvoient la liste, ou null si le serveur est injoignable / en erreur.
    getStatistiquesApp:async()=>BackendAPI.lireListe("getStatistiquesAppAccounting"),
    getStatistiquesJeux:async()=>BackendAPI.lireListe("getStatistiquesJeuxAccounting"),
    lireListe:async(type)=>{
        try {
            const response = await fetch(urlBack, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ type, data:{} }),
            })
            if (!response.ok) throw new Error(`Erreur HTTP : ${response.status}`)
            const data = await response.json()
            return Array.isArray(data) ? data : null
        } catch (error) {
            console.error("Erreur " + type + " :", error)
            return null
        }
    },
};
export default BackendAPI